import { AbstractBaseLayerState } from '../../../../../../cross-team-shared/annotation/shared/state/layers/abstract-base-layer-state';
import { TransientMeshLayerState } from '../../../../../../outputs/annotation/point-cloud/state/transient-mesh-layer-state';
import { ShapeLayerState } from './shape-layer-state';

export class MeshLayerState
  extends AbstractBaseLayerState
  implements ShapeLayerState
{
  override readonly type = 'mesh';

  constructor(public transient: TransientMeshLayerState) {
    super(0, 0);
  }
}
